// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var orderRouter = {
  path: '/order',
  component: Layout,
  redirect: '/order/index',
  name: 'Order',
  alwaysShow: true,
  meta: {
    title: '订单',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/order/index');
    },
    name: 'OrderIndex',
    meta: {
      title: '订单'
    }
  }, {
    path: 'orderList',
    name: 'orderList',
    component: function component() {
      return import('@/views/orderList/order');
    },
    meta: {
      title: '订单管理',
      icon: ''
    },
    children: [{
      path: 'lists',
      name: 'lists',
      component: function component() {
        return import('@/views/orderList/order/lists');
      },
      meta: {
        title: '订单列表',
        icon: ''
      }
    }, {
      path: 'thirdOrder',
      name: 'thirdOrder',
      component: function component() {
        return import('@/views/orderList/order/thirdOrder');
      },
      meta: {
        title: '三方订单',
        icon: ''
      }
    }, {
      path: 'customerOrder',
      name: 'customerOrder',
      component: function component() {
        return import('@/views/orderList/order/customerOrder');
      },
      meta: {
        title: '客户订单',
        icon: ''
      }
    }, {
      path: 'customerOrderPre',
      name: 'customerOrderPre',
      component: function component() {
        return import('@/views/orderList/order/customerOrderPre');
      },
      meta: {
        title: '客户预制卡订单管理',
        icon: ''
      }
    }, {
      path: 'movieLists',
      name: 'movieLists',
      component: function component() {
        return import('@/views/orderList/order/movieLists');
      },
      meta: {
        title: '电影订单',
        icon: ''
      }
    }, {
      path: 'houseOrder',
      name: 'houseOrder',
      component: function component() {
        return import('@/views/orderList/order/houseOrder');
      },
      meta: {
        title: '家政订单',
        icon: ''
      }
    }, {
      path: 'pintuanOrder',
      name: 'pintuanOrder',
      component: function component() {
        return import('@/views/orderList/order/pintuanOrder');
      },
      meta: {
        title: '拼团订单',
        icon: ''
      }
    }, {
      path: 'dangaoOrder',
      name: 'dangaoOrder',
      component: function component() {
        return import('@/views/orderList/order/dangaoOrder');
      },
      meta: {
        title: '蛋糕订单',
        icon: ''
      }
    }, {
      path: 'supplierOrder',
      name: 'supplierOrder',
      component: function component() {
        return import('@/views/orderList/order/supplierOrder');
      },
      meta: {
        title: '供应商订单',
        icon: ''
      }
    }, {
      path: 'wtoOrderlist',
      name: 'wtoOrderlist',
      component: function component() {
        return import('@/views/orderList/order/wtoOrderlist');
      },
      meta: {
        title: '核销订单',
        icon: ''
      }
    }, {
      path: 'mealOrder',
      name: 'mealOrder',
      component: function component() {
        return import('@/views/orderList/order/mealOrder');
      },
      meta: {
        title: '点餐订单',
        icon: ''
      }
    }, {
      path: 'hotelOrder',
      name: 'hotelOrder',
      component: function component() {
        return import('@/views/orderList/order/hotelOrder');
      },
      meta: {
        title: '酒店订单',
        icon: ''
      }
    }, {
      path: 'offset',
      name: 'offset',
      component: function component() {
        return import('@/views/orderList/order/offset');
      },
      meta: {
        title: '核销订单列表',
        icon: ''
      }
    }, {
      path: 'orderOffset',
      name: 'orderOffset',
      component: function component() {
        return import('@/views/orderList/order/orderOffset');
      },
      meta: {
        title: '核销退款列表',
        icon: ''
      }
    }, {
      path: 'sjt',
      name: 'sjt',
      component: function component() {
        return import('@/views/orderList/order/sjt');
      },
      meta: {
        title: '三甲通套餐订单',
        icon: ''
      }
    }, {
      path: 'fuCard',
      name: 'fuCard',
      component: function component() {
        return import('@/views/orderList/order/fuCard');
      },
      meta: {
        title: '福卡订单列表',
        icon: ''
      }
    }, {
      path: 'sj_shopCarList',
      name: 'sj_shopCarList',
      component: function component() {
        return import('@/views/orderList/order/sj_shopCarList');
      },
      meta: {
        title: '停车订单',
        icon: ''
      }
    }, {
      path: 'sj_shopCarCardList',
      name: 'sj_shopCarCardList',
      component: function component() {
        return import('@/views/orderList/order/sj_shopCarCardList');
      },
      meta: {
        title: '停车卡订单',
        icon: ''
      }
    }, {
      path: 'jdOrderList',
      name: 'jdOrderList',
      component: function component() {
        return import('@/views/orderList/order/jdOrderList/index');
      },
      meta: {
        title: '京东订单列表',
        icon: ''
      }
    }, {
      path: 'samOrderList',
      name: 'samOrderList',
      component: function component() {
        return import('@/views/orderList/order/samOrderList/index');
      },
      meta: {
        title: '山姆订单列表',
        icon: ''
      }
    },
    //三江直饮水订单
    {
      path: 'sanjiang',
      name: 'sanjiang',
      component: function component() {
        return import('@/views/orderList/order/sanjiang');
      },
      meta: {
        title: '三江直饮水订单',
        icon: ''
      }
    }, {
      path: 'sj_oil',
      name: 'sj_oil',
      component: function component() {
        return import('@/views/orderList/order/sj_oil');
      },
      meta: {
        title: '油品订单',
        icon: ''
      }
    }, {
      path: 'downloadTask',
      name: 'downloadTask',
      component: function component() {
        return import('@/views/orderList/order/downloadTask');
      },
      meta: {
        title: '导出任务',
        icon: ''
      }
    }, {
      path: 'integralOrder',
      name: 'integralOrder',
      component: function component() {
        return import('@/views/orderList/order/integralOrder/index');
      },
      meta: {
        title: '积分订单',
        icon: ''
      }
    }]
  }, {
    path: 'orderTag',
    name: 'orderTag',
    component: function component() {
      return import('@/views/orderList/order/orderTag');
    },
    meta: {
      title: '订单标签管理'
    }
  }, {
    path: 'orderpay',
    name: 'orderpay',
    component: function component() {
      return import('@/views/orderList/order/orderpay');
    },
    meta: {
      title: '交易记录'
    }
  }, {
    path: 'aftersale',
    name: 'aftersale',
    component: function component() {
      return import('@/views/aftersale/index');
    },
    meta: {
      title: '售后管理'
    }
  }, {
    path: 'aftersale/aftersaleDetail/:aftersaleNo?/:orderNo?/:type?',
    component: function component() {
      return import('@/views/aftersale/aftersaleDetail');
    },
    name: 'SortCreat',
    meta: {
      title: '售后查看',
      noCache: true,
      activeMenu: "/order/aftersale"
    },
    hidden: true
  }]
};
export default orderRouter;